import Grid from "@mui/material/Grid";
import { Button, styled, Table, TableContainer } from "@mui/material";


export const StyledTableContainer = styled(TableContainer)(({ theme, isModal }) => ({
	padding: isModal ? "0 0 15px 0" : "25px 0",
	alignSelf: "center",
}));


export const StyledTable = styled(Table)({
	overflowX: "inherit",
	// width: "60%",
	"& .MuiTableCell-root": {
		borderBottom: "none",
	},
});


export const StyledGrid = styled(Grid)(({ theme, isModal }) => ({
	// maxWidth: "55%",
	width: !isModal ? "55%" : "auto",
	...(!isModal && { marginLeft: "30px", }),
	// [theme.breakpoints.between("md", "lg")]: {
	// 	width: "100%",
	// 	transition: "width 2s",
	// },
}));


export const MainButton = styled(Button)(() => ({
	border: "none",
	padding: "7px 45px",
	borderRadius: 20,
	textTransform: "inherit",
	"&:hover": {
		border: "none",
	},
}));


export const Container = styled("div")(({ theme, isModal }) => ({
	// display: "flex",
	// justifyContent: "center",
	// flexDirection: "column",
	// maxWidth: "55%",
	width: !isModal ? "60%" : "100%",
	// [theme.breakpoints.between("md", "lg")]: {
	// 	width: "100%",
	// },
	marginBottom: "10px",
	...(!isModal && { paddingLeft: 16, }),
	minWidth: "max-content",
}));


export const CancelButton = styled(MainButton)(() => ({
	backgroundColor: "#e0e8ff",
	color: "#638dff",
	border: "none",
	fontFamily: 'Figtree, sans-serif',
	fontSize: 14,
	padding: "3px 35px",
	boxShadow: "none",
	"&:hover": {
		backgroundColor: "#eef2ff",
	},
	"&:focus": {
		boxShadow: "0 0 6px 0 rgba(99, 141, 255, 0.6)",
		backgroundColor: "#eef2ff",
	},
	"&:disabled": {
		backgroundColor: "#e8ecf8",
		color: "#aeb8d6",
	},
}));


export const ConfirmButton = styled(MainButton)(() => ({
	backgroundColor: "#638dff",
	color: "#FFFFFF",
	fontFamily: 'Figtree, sans-serif',
	fontSize: 14,
	padding: "3px 35px",
	boxShadow: "none",
	"&:hover": {
		backgroundColor: "#4c71d6",
	},
	"&:focus": {
		boxShadow: "0 0 6px 0 #638dff !important",
	},
	"&:disabled": {
		backgroundColor: "#aeb8d6",
		color: "#e8ecf8",
		border: "none",
	},
}));